<template>
    <div class="menu" ref="menu">
        <div class="container">
            <div ref="navbartoggler" class="navbar-toggler" type="button" data-toggle="collapse" @click="toggleDropdown">
               <i class="fa fa-bars" aria-hidden="true"></i>
            </div>
            <div ref="collapse" class="collapse">
                <div class="nav">
                    <router-link to="/">Home</router-link>
                    <router-link to="/about">About</router-link>
                    <router-link to="/portfolio">Portfolio</router-link>
                    <router-link to="/contact">Contact</router-link>
                </div>
                <div class="social">
                    <a href="https://instagram.com/thoulessart" target="_blank" id="instagram" >
                        <i class="nf nf-fa-instagram"></i>
                        <div class="name">
                            /thoulessart
                        </div>
                    </a>
                    <a href="https://twitter.com/thoulessart" target="_blank" id="twitter" >
                        <i class="nf nf-fa-twitter"></i> 
                        <div class="name">
                            @thoulessart
                        </div>
                    </a>
                    <a href="https://www.teepublic.com/user/thouless_art" target="_blank" id="teepublic" >
                        <i class="nf nf-mdi-cart_outline"></i>
                        <div class="name">
                            Shop
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                timeout: null
            }
        },
        mounted() {
            this.observer = new IntersectionObserver( 
                ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
                {threshold: [1]}
            );

            this.observer.observe(document.querySelector('.menu'));


            window.addEventListener('resize', this.handleResize);

        },
        beforeDestroy() {
            this.observer.unobserve(document.querySelector('.menu'));
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            handleResize() {
                if(screen.width > 1100) {
                    if(this.$refs.collapse.classList.contains('open')) {
                        this.$refs.collapse.classList.remove('open');
                        this.$refs.menu.classList.remove('open');
                    }
                }
            },
            toggleDropdown() {
                if(this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }

                if(!this.$refs.collapse.classList.contains('open')) {
                    this.$refs.collapse.classList.remove('closing');
                    this.$refs.collapse.classList.add('open');
                    this.$refs.menu.classList.add('open');
                } else {
                    this.$refs.collapse.classList.add('closing');
                    this.$refs.collapse.classList.remove('open');
                    this.$refs.menu.classList.remove('open');

                    this.timeout = setTimeout(() => {
                        this.$refs.collapse.classList.remove('closing');
                    }, 1000)
                }
                this.dropdownState = !this.dropdownState;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .menu {
        position: sticky;
        top: -1px;

        background-color: #121212;
        padding: 20px;

        z-index: 1000;
        transition: background-color ease 0.3s;

        .container {
            margin: 0 10%;
        }

        .navbar-toggler {
            display: none;
            color: rgba(255,255,255,0.87);
            font-size: 1.2em;
            padding: 10px 0;
        }

        .collapse {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            max-height: 300px;
            overflow: hidden;

            transition: max-height 0.5s ease;

            &.closing {
                display: block !important;
                flex-direction: column;
                text-align: center;
                height: 100%;
                max-height: 0vh !important;
                position: relative;

                .nav {
                    flex-direction: column;
                    width: 100%;

                    a {
                        padding: 10px 0;
                    }
                }

                .social {
                    width: 100% !important;

                    a {
                        padding: 15px 15px 0;
                    }
                }
            }

            &.open {
                display: block !important;
                flex-direction: column;
                text-align: center;
                
                height: 100%;
                max-height: 300px !important;

                .nav {
                    flex-direction: column;
                    width: 100%;

                    a {
                        padding: 10px 0;
                    }
                }

                .social {
                    width: 100% !important;

                    a {
                        padding: 15px 15px 0;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1100px) {
        .collapse {
            max-height: 0 !important;
            height: 0;
        }

        .navbar-toggler {
            display: block !important;
        }
    }

    .menu[stuck], .menu.open {
        background-color: #242424;
        box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    }

    .nav {
        display: flex;
        justify-content: space-evenly;
        width: 50%;

        a {
            color: rgba(255,255,255,0.87);
            text-decoration: none;
            text-transform: uppercase;
            font-weight: 500;
            font-size: 1.2em;

            &:hover {
                color: rgba(255,255,255,1);
            }
        }
    }

    .open .social a:hover .name {
        height: 0 !important;
        width: 0 !important;
    }

    .social {
        position: relative;
        // top: -55px;
        text-align: center;
        display: flex;
        justify-content: space-evenly;

        width: 50%;

        i {
            font-size: 2.25em;
            position: relative;
        }

        a {
            display: inline-block;
            padding: 0 20px;
            color: rgba(255,255,255,0.87);
            transition: height 0.3s ease;
            text-decoration: none;

            &:hover {
                opacity: 0.6;

                .name {
                    height: 1em;
                    width: 175px;
                }
            }
        }

        img {
            vertical-align: middle;
        }

        .name {
            font-family: futura-pt, sans-serif;
            font-size: 1.9em;
            font-weight: 300;
            display: inline-block;
            position: relative;
            top: 0;
            left: 15px;

            width: 0px;
            height: 0px;
            overflow: hidden;
            word-wrap: none;
            word-break: keep-all;
            transition: 0.3s ease all;
        }
    }

</style>